var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"imgBox min-w-1400"},[_c('div',{staticClass:"imgBox1 min-w-1400"},[_c('div',{staticClass:"img1 max-w-1400"},[_c('img',{staticClass:"imgItem1",attrs:{"src":_vm.importedImg1,"alt":""}})])]),_vm._m(0),_vm._m(1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"imgBox2 min-w-1400"},[_c('div',{staticClass:"img2 max-w-1400"})])
},function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"imgBox6 min-w-1400"},[_c('div',{staticClass:"img6 max-w-1400"})])
}]

export { render, staticRenderFns }